import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { PolicyPrivacy } from '../../components/policyPrivacy';

const Header: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: '10vh' }}>
      <center>
          <Link to='/' style={{ padding: '.2em' }}>
            <span>
              {t("Main Page")}
            </span>
          </Link>
      </center>
    </div>
  );
}

export const PolicyPrivacyInfo: React.FC = () => {
  return (
    <div style={{ margin: 0, padding: 0, height: '100vh', overflow: 'hidden' }}>
      <div style={{ display: "flex", flexDirection: 'column', justifyContent: "space-between" }}>
        <Header />
        <PolicyPrivacy />
      </div>
    </div>
  );
}
